// eslint-disable-next-line import/no-anonymous-default-export
export default {
	urlAPI: "https://api-tepozan.ketxal.com:83/v1.0",
	apiKey: "7f65f99df-80f0-4227-a7c7-1f2701762452",
	clientId: "717992ef-f530-42c7-b5cf-8dab7c379a53",
}